import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {},
})
export default class TheHeader extends Vue {
  goToHome() {
    // window.location.href = "https://mytownkl.com.my/";
    this.$router.push({ name: "Home" });
  }
}
